// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6b092aab].email-input label {\n  font-size: 14px;\n  color: #424f62;\n  opacity: 0.5;\n}\n[data-v-6b092aab].email-input .v-input__append-inner {\n  display: none;\n}\n[data-v-6b092aab].email-input .v-input__slot {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  min-height: 32px !important;\n  padding: 6px 12px !important;\n}", ""]);
// Exports
module.exports = exports;
